import styled from 'styled-components';

export const Input = styled.input`
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  font-size: 16px;
  
  &:focus {
    outline: none;
    border-color: #007bff;
  }
`; 